import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  return {
    user: searchParams.get('user') || null,
    // видео фон
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,
    title: searchParams.get('title') || 'программа / шоу / ведущий',
    speedSlow: searchParams.get('speedSlow')
      ? Number(searchParams.get('speedSlow') || '')
      : 3,
    speedFast: searchParams.get('speedFast')
      ? Number(searchParams.get('speedFast') || '')
      : 8,
    titleFontSize: searchParams.get('titleFontSize') || 11,
    msgFontSize: searchParams.get('msgFontSize') || 4.2,
    marginMsg: searchParams.get('marginMsg') || 0,
    // ========
    bg: searchParams.get('bg') || null,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 1000,
    duration: searchParams.get('duration')
      ? parseInt(searchParams.get('duration') || '')
      : 1000,
  };
};
